"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryWidgetViewState = void 0;
var GalleryWidgetViewState;
(function (GalleryWidgetViewState) {
    GalleryWidgetViewState["DEFAULT"] = "default";
    GalleryWidgetViewState["QUICK_ADD"] = "quick-add";
})(GalleryWidgetViewState = exports.GalleryWidgetViewState || (exports.GalleryWidgetViewState = {}));
//# sourceMappingURL=galleryWidgetViewState.js.map